/**
 * 画板当前所处模式
 */
export enum ICanvasMode {
  DRAG = "drag",
  SELECT = "select",
  DRAW = "draw",
  ERASE = "erase",
  TEXT = "text",
  SHAPE = "shape",
  STICKERS = "stickers",
}
